(function () {

  'use strict';

  var ItxFiltersCmp = {
    bindings: {
      onNewFilters: '&',
      onSetFilters: '&',
      isOpenFilter: '<',
      setFilter: '<',
      categoryFilter: '<'
    },
    controller: ItxFiltersCmpCtrl,
    templateUrl: 'filters.component.html'
  };

  angular.module('itxApp.catalog').component('itxFilters', ItxFiltersCmp);

  ItxFiltersCmpCtrl.$inject = [
    '$timeout',
    'ItxFiltersManagerSvc',
    'ItxScreenSizeSvc',
    'ItxUtilsFct',
    'imCategoryFilter',
    'ItxTranslateSvc',
    'ngDialog'
  ];

  function ItxFiltersCmpCtrl(
    $timeout,
    ItxFiltersManagerSvc,
    ItxScreenSizeSvc,
    ItxUtilsFct,
    imCategoryFilter,
    ItxTranslateSvc,
    ngDialog
  ) {

    var _this = this;
    var activeSection = '';
    _this.isActiveOrder = false;
    _this.reloadFilterItem = false;
    _this.isMobile = ItxScreenSizeSvc.isMobile();
    _this.isReady = false;

    _this.filters = null;
    _this.selectedSizes = [];
    _this.priceRange = [];
    _this.formatPrice = inditex.formatPrice.bind(inditex);

    _this.ItxFiltersManagerSvc = ItxFiltersManagerSvc;
    _this.ItxScreenSizeSvc = ItxScreenSizeSvc;
    //Initialize component
    _this.$onInit = function () {

      _this.initFilters();


          _this.isReady = true;
          inditex.removeSessionStorage('imCategoryFilters');
    };

    _this.$onChanges = function (changes) {
      var somethingChanged = ( changes.setFilter &&
                               !changes.setFilter.isFirstChange() && 
                               changes.setFilter.currentValue != changes.setFilter.previousValue);
      if (somethingChanged) {
        _this.setFilters();
      }
    };

    _this.close = function () {
      ngDialog.close();
      $('body').removeClass('open-filter');
      $('body').addClass('closed-filter');
      _this.isActiveOrder = false;
    };

    _this.openOrder = function($event){
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();    
      }
      _this.isActiveOrder = !_this.isActiveOrder;
    };

    _this.initFilters = function () {
      //Get ALL the filters for ALL the products in the product grid
      _this.filters = joyr.catalog.utils.getFilters(
        ItxFiltersManagerSvc.getProducts(), ['XCATFILTER', 'XTYPEFILTER', 'XCALFILTER']);

      _this.filters.sizes = _this.filters.sizes.sort(joyr.catalog.utils.sortiSzesFunction);
      _this.sizesCategory = ItxFiltersManagerSvc.getCategoryPathFilter();
      if (_this.sizesCategory.length > 0) {
        _this.filters.sizes = ItxFiltersManagerSvc.removeVisibleFiltersByCategoryPath(_this.filters.sizes);
      }
      //_this.originalFilters = Object.assign({}, _this.filters); 
    };
    
    _this.setFilters = function() {
      _this.filters.attributes['XTYPEFILTER'] = _this.setFiltersSelected('types', 'XTYPEFILTER');
      _this.filters.attributes['XCALFILTER'] = _this.setFiltersSelected('qualities', 'XCALFILTER');
      _this.filters.attributes['XCATFILTER'] = _this.setFiltersSelected('characteristics', 'XCATFILTER');
      _this.filters.colors =  _this.setFiltersSelected('colors');
      _this.setFiltersSizeSelected('sizes');
      _this.reloadFilterItem = !_this.reloadFilterItem;

      _this.totalProducts = ItxFiltersManagerSvc.getProductCount();
    };

    ItxScreenSizeSvc.when('xs,sm,md,lg', function () {
      if (ItxScreenSizeSvc.is('md,lg')) {
        ngDialog.close();
      }
    });

    _this.removeFilter = function (filter) {
      ItxFiltersManagerSvc.removeFilter(filter);
      _this.onNewFilters();
    };

    _this.getSelected = function (key) {
      var labels = [];

      if (key === 'sizes') {
        _.each(_this.filters.sizes, function (size) {
          if (_this.selectedSizes[size] === true) {
            labels.push(size);
          }
        });
      } else if (['types', 'qualities', 'characteristics', 'colors'].indexOf(key) !== -1) {
        //Attrs & Colors
        var selected = [], obj = null;

        if (key === 'colors') {
          obj = _this.filters[key];
        } else if (key === 'types') {
          obj = _this.filters.attributes['XTYPEFILTER'];
        } else if (key === 'qualities') {
          obj = _this.filters.attributes['XCALFILTER'];
        } else if (key === 'characteristics') {
          obj = _this.filters.attributes['XCATFILTER'];
        }

        selected = _.filter(obj, function (filter) {
          return filter.selected;
        });

        labels = _.map(selected, 'label');

      } else if (key === 'price') {
        if (_this.filters.prices.min !== _this.filters.prices.minStep ||
          _this.filters.prices.max !== _this.filters.prices.maxStep) {
          labels.push(ItxTranslateSvc.translateCms('legacy.ItxCategoryPage.filter.from') + _this.formatPrice(_this.filters.prices.min));
          labels.push(ItxTranslateSvc.translateCms('legacy.ItxCategoryPage.filter.to') + _this.formatPrice(_this.filters.prices.max));
        }
      } else if (key === 'order') {
        if (_this.filters.order === 'newer') {
          labels.push(ItxTranslateSvc.translateCms('legacy.ItxCategoryPage.filter.newer'));
        } else if (_this.filters.order === 'relevance') {
          labels.push(ItxTranslateSvc.translateCms('legacy.ItxCategoryPage.orden.relevancia'));
        } else if (_this.filters.order === 'priceAscending') {
          labels.push(ItxTranslateSvc.translateCms('legacy.ItxCategoryPage.filter.priceAscending'));
        } else if (_this.filters.order === 'priceDescending') {
          labels.push(ItxTranslateSvc.translateCms('legacy.ItxCategoryPage.filter.priceDescending'));
        }
      }

      if (labels.length) {
        return labels.length;
        //return '(' + labels.join() + ')';
      } else {
        return '';
      }
    };

    // Al pulsar sobre aplicar filtros
    _this.apply = function () {
      var sizes = [];

      for (var size in _this.selectedSizes) {
        if (_this.selectedSizes[size] === true) {
          sizes.push(size);
        }
      }
      // Aplicar filtros de price por categoría.
      if (_this.categoryFilter.filterPrice) {
        _this.filters.prices.min = _this.categoryFilter.filterPrice.min;
        _this.filters.prices.max = _this.categoryFilter.filterPrice.max;
      }

      ItxFiltersManagerSvc.applyFilters(
        _.filter(_this.filters.attributes['XTYPEFILTER'], function (attr) { return attr.selected; }),
        _.filter(_this.filters.attributes['XCALFILTER'], function (attr) { return attr.selected; }),
        _.filter(_this.filters.attributes['XCATFILTER'], function (attr) { return attr.selected; }),
        _.filter(_this.filters.colors, function (attr) { return attr.selected; }),
        sizes,
        _this.filters.prices,
        _this.filters.order
      ).then(function () {
        _this.onNewFilters();      
        imCategoryFilter.applySize(sizes);
        //imCategoryFilter.applyPrice(_this.filters.prices);
        imCategoryFilter.applyColor(_this.filters.colors);
        imCategoryFilter.applyAllAttr(_this.filters.attributes);
        imCategoryFilter.applyOrder(_this.filters.order);
      });
    };

    _this.clean = function () {
      //imCategoryFilter.applySize(_this.selectedSizes);
      //imCategoryFilter.applyOrder(_this.filters.order);

      _this.selectedSizes = [];
      for (var key in _this.filters.attributes) {
        if (_this.filters.attributes.hasOwnProperty(key)) {
          _.each(_this.filters.attributes[key], function (attr) {
            delete attr['selected'];
            //imCategoryFilter.deleteAllAttr(_this.filters.attributes);
          });
        }
      }

      _.each(_this.filters.colors, function (attr) {
        delete attr['selected'];
        //imCategoryFilter.deleteColor(_this.filters.colors);
      });

      _this.filters.prices.min = _this.filters.prices.minStep;
      _this.filters.prices.max = _this.filters.prices.maxStep;

      _this.filters.order = '';
      _this.apply();
      //inditex.removeSessionStorage('imCategoryFilters');
    };

    _this.anyFilterSelected = function () {
      //Sizes
      var sizeSelected = false;

      for (var prop in _this.selectedSizes) {
        if (_this.selectedSizes[prop]) {
          sizeSelected = true;
        }
      }

      if (sizeSelected) {
        return true;
      }

      //Attrs
      var attrSelected = false;

      _.each(_this.filters.attributes, function (attr) {
        _.each(attr, function (item) {
          if (item.selected) {
            attrSelected = true;
          }
        });
      });

      if (attrSelected) {
        return true;
      }

      //Colors
      if (_.find(_this.filters.colors, function (color) { return color.selected; })) {
        return true;
      }
      //Prices
      if ((_this.filters.prices.max !== _this.filters.prices.maxStep) ||
        (_this.filters.prices.min !== _this.filters.prices.minStep)) {
        return true;
      }

      //Order
      if (_this.filters.order) {
        return true;
      }
    
      return false;
    };

    _this.getSizesColumns = function () {
      if (ItxUtilsFct.isChildrenCategory(inditex.iCategoryJSON)) {
        return 'col-xs-12 col-sm-6 col-md-3';
      } else {
        return 'col-xs-4 col-md-2';
      }
    };

    _this.setFiltersSelected = function(name, attr) {
      let filtersSelected = ItxFiltersManagerSvc.getSelectedFilters(name);
      let array;
      if(attr){
        array = _this.filters.attributes[attr];
      } else {
        array = _this.filters[name];
      }
      if(array){
        if(filtersSelected.length > 0){
          _.each(array, function (item) {
            item.selected = false;
            _.each(filtersSelected, function (newItem) {
              if (item.value === newItem.value) {
                item.selected = true;
              }
            });
          });
        } else {
          _.each(array, function (item) {
            item.selected = false;
          });
        }
        return array;
      } else {
        return null;
      }
    };

    _this.setFiltersSizeSelected = function(name) {
      let filtersSelected = ItxFiltersManagerSvc.getSelectedFilters(name);
      _this.selectedSizes = [];
      if(filtersSelected.length > 0){
        _.each(filtersSelected, function (size) {
          _this.selectedSizes[size.value] = true;
        });
      }
    };
  }

})();
